import {
  IMCChannelShownFields,
  MCCreateChannelResponse,
  TelegramBotChannelState,
  entities,
} from '../../../api/proto';
import {randomUint8Array} from '../../../utils/arrayUtils';
import wait from '../../../utils/wait';
import Channel from '../Channel';
import {ChannelsUpdaterEvent} from '../ChannelsUpdater';
import TelegramBot from './TelegramBot/TelegramBot';

export class TelegramBotEmulator extends TelegramBot {
  createChannel = async (token: string, shownFields?: IMCChannelShownFields | null) => {
    console.debug('TelegramBotEmulator.createChannel', {token, shownFields});
    if (this.loading) {
      return {error: {message: 'In process'}, res: null};
    }

    // Validate token format (basic check)
    if (!token || token.trim().length === 0) {
      return {error: {message: 'Invalid token'}, res: null};
    }

    const channelID = randomUint8Array();
    const createChannelRes = new MCCreateChannelResponse({
      channelID,
      result: MCCreateChannelResponse.Result.R_OK,
    });

    let newChannel: Channel | null = null;

    if (createChannelRes) {
      newChannel = new Channel(
        {
          channelID: createChannelRes?.channelID,
          shownFields: shownFields,
          type: entities.OzekonChannelType.OIT_TELEGRAM_BOT,
          workspaceID: this.channels.workspace.id,
          state: {
            telegramBot: {
              state: TelegramBotChannelState.State.CREATE_CHANNEL,
            },
          },
        },
        this.channels.workspace,
      );
    }

    this.setProcessingRequest_(null);
    this.setLoading(true);
    await wait(1500);
    this.setLoading(false);

    this.emulateChannelActivation(newChannel);

    return {error: null, res: createChannelRes, channel: newChannel};
  };

  private emulateChannelActivation = async (newChannel: Channel | null) => {
    await wait(1000);
    this.emulateChannelsLoad(newChannel);
    await wait(2000);
    this.emulateUpdateEvent(newChannel);
  };

  private emulateChannelsLoad = (newChannel: Channel | null) => {
    console.debug('TelegramBotEmulator.emulateChannelsLoad', newChannel?.uuid);
    newChannel &&
      this.channels.setChannels([
        ...this.channels.list,
        new Channel(
          {
            channelID: newChannel?.id,
            shownFields: newChannel.shownFields,
            type: newChannel.type,
            workspaceID: newChannel.workspace.id,
            state: {
              telegramBot: {
                state: TelegramBotChannelState.State.CREATE_CHANNEL,
              },
            },
          },
          this.channels.workspace,
        ),
      ]);
  };

  private emulateUpdateEvent = (newChannel: Channel | null) => {
    console.debug('TelegramBotEmulator.emulateUpdateEvent', newChannel?.uuid);
    this.channels.workspace.updater.emit(ChannelsUpdaterEvent.UPDATE, {
      channelID: newChannel?.id,
      updateChannelState: {
        newState: {
          telegramBot: {
            state: TelegramBotChannelState.State.EVENT_LISTENING,
          },
          identifiers: {
            username: 'emulated_bot',
          },
        },
      },
    });
  };
}

export default TelegramBotEmulator;
